import React from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import { hideModalAction } from "../../modules/Modals/Actions";
import ModalContainer from "./ModalContainer";
import { Formik, Form } from "formik";
import { TextArea, Select } from "../form/index";

const subjectOptions = [
  { value: "0", label: "Artisan Incomplete Data" },
  { value: "1", label: "Supplier Incomplete Data" },
  { value: "2", label: "Customer Incomplete Data" },
  { value: "3", label: "Artisan Invalid Data" },
  { value: "4", label: "Supplier Invalid Data" },
  { value: "5", label: "Customer Invalid Data" },
  { value: "6", label: "Artisan Logo Review" },
  { value: "7", label: "Supplier Logo Review" },
  { value: "8", label: "Artisan Product Images Review" },
  { value: "9", label: "Supplier Product Images Review" },
  { value: "10", label: "Artisan Private Inquiry Data Review" },
  { value: "11", label: "Supplier Private Inquiry Data Review" },
  { value: "12", label: "Artisan Public Inquiry Data Review" },
  { value: "13", label: "Artisan Public Inquiry Attachment Review" },
  { value: "14", label: "Supplier Public Inquiry Data Review" },
  { value: "14", label: "Supplier Public Inquiry Attachment Review" },
];

const ContactUser = ({ id, hideModal }) => (
  <ModalContainer title='Contact User'>
    <Formik
      initialValues={{
        subject: "",
        message: "",
      }}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className='kt-portlet__body'>
              <Select options={subjectOptions} label='Subject' name='subject' />
              <TextArea name='message' label='Message' />
          </div>
          <div className='kt-portlet__foot'>
            <div className='kt-form__actions'>
              <div className='row'>
                <div className='col-12 ml-lg-auto'>
                  <button
                    type='button'
                    className='btn btn-md btn-success'
                    onClick={() => {
                      hideModal(id);
                    }}
                  >
                    Send
                  </button>
                  <button
                    type='button'
                    className='btn btn-md btn-label-primary ml-2'
                    onClick={() => {
                      hideModal(id);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  </ModalContainer>
);

const Close = styled.button`
  position: sticky;
  top: 29px;
  margin-left: 100%;

  transform: translateX(-100%) translateY(-100%);
`;

const List = styled.div`
  margin-top: -37px;
`;

export default connect(null, {
  hideModal: hideModalAction,
})(ContactUser);
